"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Flag = exports.VerificationStatus = exports.NotificationType = exports.FileUploadType = exports.MartindaleHubbellRatingEnum = exports.LanguageEnum = exports.CompetencyEnum = exports.VolumeEnum = exports.CurrencyCodeEnum = exports.AreaOfLawEnum = exports.CountryEnum = exports.StateEnum = exports.PhoneTypeEnum = exports.Race = exports.Gender = exports.ProviderType = exports.NetworkEnum = exports.StatusEnum = exports.ActionEnum = void 0;
var ActionEnum;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
    ActionEnum["DEACTIVATE"] = "DEACTIVATE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["UPDATE_ADDRESSES"] = "UPDATE_ADDRESSES";
    ActionEnum["UPDATE_AREAS_OF_PRACTICE"] = "UPDATE_AREAS_OF_PRACTICE";
    ActionEnum["UPDATE_ASSOCIATED_BRANCHES"] = "UPDATE_ASSOCIATED_BRANCHES";
    ActionEnum["UPDATE_ASSOCIATIONS"] = "UPDATE_ASSOCIATIONS";
    ActionEnum["UPDATE_AWARDS"] = "UPDATE_AWARDS";
    ActionEnum["UPDATE_BAR_STATES"] = "UPDATE_BAR_STATES";
    ActionEnum["UPDATE_BIOGRAPHY"] = "UPDATE_BIOGRAPHY";
    ActionEnum["UPDATE_CONTACT_INFO"] = "UPDATE_CONTACT_INFO";
    ActionEnum["UPDATE_CRITICAL_NOTES"] = "UPDATE_CRITICAL_NOTES";
    ActionEnum["UPDATE_DISCIPLINARY_ACTIONS"] = "UPDATE_DISCIPLINARY_ACTIONS";
    ActionEnum["UPDATE_EDUCATION"] = "UPDATE_EDUCATION";
    ActionEnum["UPDATE_EMAIL_ADDRESS"] = "UPDATE_EMAIL_ADDRESS";
    ActionEnum["UPDATE_FIRM"] = "UPDATE_FIRM";
    ActionEnum["UPDATE_PROVIDER_TYPE"] = "UPDATE_PROVIDER_TYPE";
    ActionEnum["UPDATE_LANGUAGES"] = "UPDATE_LANGUAGES";
    ActionEnum["UPDATE_LEGAL_SHIELD_JOIN_YEAR"] = "UPDATE_LEGAL_SHIELD_JOIN_YEAR";
    ActionEnum["UPDATE_NOTIFICATION_HISTORY"] = "UPDATE_NOTIFICATION_HISTORY";
    ActionEnum["UPDATE_PHONE_NUMBERS"] = "UPDATE_PHONE_NUMBERS";
    ActionEnum["UPDATE_PRACTICE_BEGIN_DATE"] = "UPDATE_PRACTICE_BEGIN_DATE";
    ActionEnum["UPDATE_PROFILE_PICTURE_URL"] = "UPDATE_PROFILE_PICTURE_URL";
    ActionEnum["UPDATE_PROVIDER_NAME"] = "UPDATE_PROVIDER_NAME";
    ActionEnum["UPDATE_PUBLICATIONS"] = "UPDATE_PUBLICATIONS";
    ActionEnum["UPDATE_RATING"] = "UPDATE_RATING";
    ActionEnum["UPDATE_REFERRING_ENTITY"] = "UPDATE_REFERRING_ENTITY";
    ActionEnum["UPDATE_SPEAKING_ENGAGEMENTS"] = "UPDATE_SPEAKING_ENGAGEMENTS";
    ActionEnum["UPDATE_TAX_ID"] = "UPDATE_TAX_ID";
    ActionEnum["UPDATE_VERIFICATION"] = "UPDATE_VERIFICATION";
    ActionEnum["UPDATE_WEBSITE_URL"] = "UPDATE_WEBSITE_URL";
    ActionEnum["ADD_FILE_UPLOAD"] = "ADD_FILE_UPLOAD";
    ActionEnum["REMOVE_FILE_UPLOAD"] = "REMOVE_FILE_UPLOAD";
    ActionEnum["UPDATE_FILE_UPLOADS"] = "UPDATE_FILE_UPLOADS";
    ActionEnum["UPDATE_FLAGS"] = "UPDATE_FLAGS";
    ActionEnum["UPDATE_INSURANCE"] = "UPDATE_INSURANCE";
    ActionEnum["UPDATE_EXTERNAL_ID"] = "UPDATE_EXTERNAL_ID";
    ActionEnum["SUSPEND"] = "SUSPEND";
    ActionEnum["MARK_INSURANCE_EXPIRED"] = "MARK_INSURANCE_EXPIRED";
    ActionEnum["MARK_INSURANCE_NEEDS_ATTENTION"] = "MARK_INSURANCE_NEEDS_ATTENTION";
    ActionEnum["MARK_PENDING_INSURANCE_EXPIRATION"] = "MARK_PENDING_INSURANCE_EXPIRATION";
    ActionEnum["UPDATE_ACCEPTING_REFERRALS"] = "UPDATE_ACCEPTING_REFERRALS";
    ActionEnum["LINK_BRANCH"] = "LINK_BRANCH";
    ActionEnum["UNLINK_BRANCH"] = "UNLINK_BRANCH";
    ActionEnum["UPDATE_NETWORK"] = "UPDATE_NETWORK";
    ActionEnum["UPDATE_SEO_FRIENDLY_PATH"] = "UPDATE_SEO_FRIENDLY_PATH";
})(ActionEnum = exports.ActionEnum || (exports.ActionEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["SUSPENDED"] = "SUSPENDED";
    StatusEnum["DELETED"] = "DELETED";
    StatusEnum["DEACTIVATED"] = "DEACTIVATED";
    StatusEnum["INSURANCE_EXPIRED"] = "INSURANCE_EXPIRED";
    StatusEnum["INSURANCE_NEEDS_ATTENTION"] = "INSURANCE_NEEDS_ATTENTION";
    StatusEnum["PENDING_INSURANCE_EXPIRATION"] = "PENDING_INSURANCE_EXPIRATION";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var NetworkEnum;
(function (NetworkEnum) {
    NetworkEnum["LEGALSHIELD"] = "LEGALSHIELD";
    NetworkEnum["CLC"] = "CLC";
})(NetworkEnum = exports.NetworkEnum || (exports.NetworkEnum = {}));
var ProviderType;
(function (ProviderType) {
    ProviderType["CLC"] = "CLC";
    ProviderType["PARTNER"] = "PARTNER";
    ProviderType["REFERRAL"] = "REFERRAL";
    ProviderType["OTHER"] = "OTHER";
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
var Gender;
(function (Gender) {
    Gender["FEMALE"] = "FEMALE";
    Gender["MALE"] = "MALE";
    Gender["PREFER_NOT_TO_ANSWER"] = "PREFER_NOT_TO_ANSWER";
})(Gender = exports.Gender || (exports.Gender = {}));
var Race;
(function (Race) {
    Race["AFRICAN_AMERICAN"] = "AFRICAN_AMERICAN";
    Race["ALASKAN_NATIVE"] = "ALASKAN_NATIVE";
    Race["ASIAN"] = "ASIAN";
    Race["EUROPEAN"] = "EUROPEAN";
    Race["HISPANIC"] = "HISPANIC";
    Race["INDIAN"] = "INDIAN";
    Race["NATIVE_AMERICAN"] = "NATIVE_AMERICAN";
    Race["WHITE"] = "WHITE";
})(Race = exports.Race || (exports.Race = {}));
var PhoneTypeEnum;
(function (PhoneTypeEnum) {
    PhoneTypeEnum["OFFICE"] = "OFFICE";
    PhoneTypeEnum["DESK"] = "DESK";
    PhoneTypeEnum["TOLL_FREE"] = "TOLL_FREE";
    PhoneTypeEnum["MOBILE"] = "MOBILE";
    PhoneTypeEnum["FAX"] = "FAX";
    PhoneTypeEnum["OTHER"] = "OTHER";
})(PhoneTypeEnum = exports.PhoneTypeEnum || (exports.PhoneTypeEnum = {}));
var StateEnum;
(function (StateEnum) {
    StateEnum["AB"] = "AB";
    StateEnum["AK"] = "AK";
    StateEnum["AL"] = "AL";
    StateEnum["AR"] = "AR";
    StateEnum["AZ"] = "AZ";
    StateEnum["BC"] = "BC";
    StateEnum["CA"] = "CA";
    StateEnum["CA2"] = "CA_2";
    StateEnum["CO"] = "CO";
    StateEnum["CT"] = "CT";
    StateEnum["DC"] = "DC";
    StateEnum["DE"] = "DE";
    StateEnum["FL"] = "FL";
    StateEnum["GA"] = "GA";
    StateEnum["GU"] = "GU";
    StateEnum["HI"] = "HI";
    StateEnum["IA"] = "IA";
    StateEnum["ID"] = "ID";
    StateEnum["IL"] = "IL";
    StateEnum["IN"] = "IN";
    StateEnum["KS"] = "KS";
    StateEnum["KY"] = "KY";
    StateEnum["LA"] = "LA";
    StateEnum["LS"] = "LS";
    StateEnum["MA"] = "MA";
    StateEnum["MB"] = "MB";
    StateEnum["MD"] = "MD";
    StateEnum["ME"] = "ME";
    StateEnum["MI"] = "MI";
    StateEnum["MN"] = "MN";
    StateEnum["MO"] = "MO";
    StateEnum["MS"] = "MS";
    StateEnum["MT"] = "MT";
    StateEnum["NB"] = "NB";
    StateEnum["NC"] = "NC";
    StateEnum["ND"] = "ND";
    StateEnum["NE"] = "NE";
    StateEnum["NF"] = "NF";
    StateEnum["NH"] = "NH";
    StateEnum["NJ"] = "NJ";
    StateEnum["NL"] = "NL";
    StateEnum["NM"] = "NM";
    StateEnum["NS"] = "NS";
    StateEnum["NT"] = "NT";
    StateEnum["NU"] = "NU";
    StateEnum["NV"] = "NV";
    StateEnum["NY"] = "NY";
    StateEnum["OH"] = "OH";
    StateEnum["OK"] = "OK";
    StateEnum["ON"] = "ON";
    StateEnum["OR"] = "OR";
    StateEnum["PA"] = "PA";
    StateEnum["PE"] = "PE";
    StateEnum["PR"] = "PR";
    StateEnum["QC"] = "QC";
    StateEnum["RI"] = "RI";
    StateEnum["SC"] = "SC";
    StateEnum["SD"] = "SD";
    StateEnum["SF"] = "SF";
    StateEnum["SK"] = "SK";
    StateEnum["TN"] = "TN";
    StateEnum["TX"] = "TX";
    StateEnum["UT"] = "UT";
    StateEnum["VA"] = "VA";
    StateEnum["VI"] = "VI";
    StateEnum["VT"] = "VT";
    StateEnum["WA"] = "WA";
    StateEnum["WI"] = "WI";
    StateEnum["WV"] = "WV";
    StateEnum["WY"] = "WY";
    StateEnum["YT"] = "YT";
})(StateEnum = exports.StateEnum || (exports.StateEnum = {}));
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["CAN"] = "CAN";
    CountryEnum["USA"] = "USA";
})(CountryEnum = exports.CountryEnum || (exports.CountryEnum = {}));
var AreaOfLawEnum;
(function (AreaOfLawEnum) {
    AreaOfLawEnum["AM"] = "AM";
    AreaOfLawEnum["AD"] = "AD";
    AreaOfLawEnum["AF"] = "AF";
    AreaOfLawEnum["AA"] = "AA";
    AreaOfLawEnum["BK"] = "BK";
    AreaOfLawEnum["BR"] = "BR";
    AreaOfLawEnum["BD"] = "BD";
    AreaOfLawEnum["BT"] = "BT";
    AreaOfLawEnum["BS"] = "BS";
    AreaOfLawEnum["CU"] = "CU";
    AreaOfLawEnum["CS"] = "CS";
    AreaOfLawEnum["CL"] = "CL";
    AreaOfLawEnum["CC"] = "CC";
    AreaOfLawEnum["CO"] = "CO";
    AreaOfLawEnum["CN"] = "CN";
    AreaOfLawEnum["CF"] = "CF";
    AreaOfLawEnum["CT"] = "CT";
    AreaOfLawEnum["CY"] = "CY";
    AreaOfLawEnum["CP"] = "CP";
    AreaOfLawEnum["CD"] = "CD";
    AreaOfLawEnum["CR"] = "CR";
    AreaOfLawEnum["DE"] = "DE";
    AreaOfLawEnum["DI"] = "DI";
    AreaOfLawEnum["DU"] = "DU";
    AreaOfLawEnum["DV"] = "DV";
    AreaOfLawEnum["ED"] = "ED";
    AreaOfLawEnum["EL"] = "EL";
    AreaOfLawEnum["EM"] = "EM";
    AreaOfLawEnum["ET"] = "ET";
    AreaOfLawEnum["EP"] = "EP";
    AreaOfLawEnum["FL"] = "FL";
    AreaOfLawEnum["FW"] = "FW";
    AreaOfLawEnum["FA"] = "FA";
    AreaOfLawEnum["FC"] = "FC";
    AreaOfLawEnum["FR"] = "FR";
    AreaOfLawEnum["GA"] = "GA";
    AreaOfLawEnum["GL"] = "GL";
    AreaOfLawEnum["GC"] = "GC";
    AreaOfLawEnum["HL"] = "HL";
    AreaOfLawEnum["IT"] = "IT";
    AreaOfLawEnum["IM"] = "IM";
    AreaOfLawEnum["ID"] = "ID";
    AreaOfLawEnum["IN"] = "IN";
    AreaOfLawEnum["JV"] = "JV";
    AreaOfLawEnum["LL"] = "LL";
    AreaOfLawEnum["LT"] = "LT";
    AreaOfLawEnum["LM"] = "LM";
    AreaOfLawEnum["LN"] = "LN";
    AreaOfLawEnum["MM"] = "MM";
    AreaOfLawEnum["ML"] = "ML";
    AreaOfLawEnum["MR"] = "MR";
    AreaOfLawEnum["MD"] = "MD";
    AreaOfLawEnum["VD"] = "VD";
    AreaOfLawEnum["NC"] = "NC";
    AreaOfLawEnum["OG"] = "OG";
    AreaOfLawEnum["PC"] = "PC";
    AreaOfLawEnum["PT"] = "PT";
    AreaOfLawEnum["PN"] = "PN";
    AreaOfLawEnum["PD"] = "PD";
    AreaOfLawEnum["PI"] = "PI";
    AreaOfLawEnum["PA"] = "PA";
    AreaOfLawEnum["PU"] = "PU";
    AreaOfLawEnum["PR"] = "PR";
    AreaOfLawEnum["PL"] = "PL";
    AreaOfLawEnum["PY"] = "PY";
    AreaOfLawEnum["TA"] = "TA";
    AreaOfLawEnum["PS"] = "PS";
    AreaOfLawEnum["RE"] = "RE";
    AreaOfLawEnum["RC"] = "RC";
    AreaOfLawEnum["RF"] = "RF";
    AreaOfLawEnum["RP"] = "RP";
    AreaOfLawEnum["SC"] = "SC";
    AreaOfLawEnum["SS"] = "SS";
    AreaOfLawEnum["SN"] = "SN";
    AreaOfLawEnum["SL"] = "SL";
    AreaOfLawEnum["TX"] = "TX";
    AreaOfLawEnum["TS"] = "TS";
    AreaOfLawEnum["TM"] = "TM";
    AreaOfLawEnum["TR"] = "TR";
    AreaOfLawEnum["TU"] = "TU";
    AreaOfLawEnum["UA"] = "UA";
    AreaOfLawEnum["VE"] = "VE";
    AreaOfLawEnum["VA"] = "VA";
    AreaOfLawEnum["WC"] = "WC";
    AreaOfLawEnum["WD"] = "WD";
    AreaOfLawEnum["ZP"] = "ZP";
    AreaOfLawEnum["WL"] = "WL";
})(AreaOfLawEnum = exports.AreaOfLawEnum || (exports.AreaOfLawEnum = {}));
var CurrencyCodeEnum;
(function (CurrencyCodeEnum) {
    CurrencyCodeEnum["USD"] = "USD";
    CurrencyCodeEnum["CAD"] = "CAD";
    CurrencyCodeEnum["MXN"] = "MXN";
    CurrencyCodeEnum["GBP"] = "GBP";
})(CurrencyCodeEnum = exports.CurrencyCodeEnum || (exports.CurrencyCodeEnum = {}));
var VolumeEnum;
(function (VolumeEnum) {
    VolumeEnum["LOW"] = "LOW";
    VolumeEnum["MEDIUM"] = "MEDIUM";
    VolumeEnum["HIGH"] = "HIGH";
})(VolumeEnum = exports.VolumeEnum || (exports.VolumeEnum = {}));
var CompetencyEnum;
(function (CompetencyEnum) {
    CompetencyEnum["UNKNOWN"] = "UNKNOWN";
    CompetencyEnum["BASIC_KNOWLEDGE"] = "BASIC_KNOWLEDGE";
    CompetencyEnum["PROFICIENT"] = "PROFICIENT";
    CompetencyEnum["SPECIALIST"] = "SPECIALIST";
    CompetencyEnum["CERTIFIED"] = "CERTIFIED";
})(CompetencyEnum = exports.CompetencyEnum || (exports.CompetencyEnum = {}));
var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["ABKHAZ"] = "ABKHAZ";
    LanguageEnum["AFAR"] = "AFAR";
    LanguageEnum["AFRIKAANS"] = "AFRIKAANS";
    LanguageEnum["AKAN"] = "AKAN";
    LanguageEnum["ALBANIAN"] = "ALBANIAN";
    LanguageEnum["AMHARIC"] = "AMHARIC";
    LanguageEnum["ARABIC"] = "ARABIC";
    LanguageEnum["ARAGONESE"] = "ARAGONESE";
    LanguageEnum["ARAMAIC"] = "ARAMAIC";
    LanguageEnum["ARMENIAN"] = "ARMENIAN";
    LanguageEnum["ASSAMESE"] = "ASSAMESE";
    LanguageEnum["AVARIC"] = "AVARIC";
    LanguageEnum["AVESTAN"] = "AVESTAN";
    LanguageEnum["AYMARA"] = "AYMARA";
    LanguageEnum["AZERBAIJANI"] = "AZERBAIJANI";
    LanguageEnum["BAMBARA"] = "BAMBARA";
    LanguageEnum["BASHKIR"] = "BASHKIR";
    LanguageEnum["BASQUE"] = "BASQUE";
    LanguageEnum["BELARUSIAN"] = "BELARUSIAN";
    LanguageEnum["BENGALI"] = "BENGALI";
    LanguageEnum["BIHARI"] = "BIHARI";
    LanguageEnum["BISLAMA"] = "BISLAMA";
    LanguageEnum["BOSNIAN"] = "BOSNIAN";
    LanguageEnum["BRETON"] = "BRETON";
    LanguageEnum["BULGARIAN"] = "BULGARIAN";
    LanguageEnum["BURMESE"] = "BURMESE";
    LanguageEnum["CAMBODIAN"] = "CAMBODIAN";
    LanguageEnum["CANTONESE"] = "CANTONESE";
    LanguageEnum["CATALAN"] = "CATALAN";
    LanguageEnum["CEBUANO"] = "CEBUANO";
    LanguageEnum["CHALDEAN"] = "CHALDEAN";
    LanguageEnum["CHAMORRO"] = "CHAMORRO";
    LanguageEnum["CHECHEN"] = "CHECHEN";
    LanguageEnum["CHICHEWA"] = "CHICHEWA";
    LanguageEnum["CHINESE"] = "CHINESE";
    LanguageEnum["CHUVASH"] = "CHUVASH";
    LanguageEnum["CORNISH"] = "CORNISH";
    LanguageEnum["CORSICAN"] = "CORSICAN";
    LanguageEnum["CREE"] = "CREE";
    LanguageEnum["CREOLE"] = "CREOLE";
    LanguageEnum["CROATIAN"] = "CROATIAN";
    LanguageEnum["CZECH"] = "CZECH";
    LanguageEnum["DANISH"] = "DANISH";
    LanguageEnum["DARI"] = "DARI";
    LanguageEnum["DIVEHI"] = "DIVEHI";
    LanguageEnum["DUTCH"] = "DUTCH";
    LanguageEnum["DZONGKHA"] = "DZONGKHA";
    LanguageEnum["ENGLISH"] = "ENGLISH";
    LanguageEnum["ESPERANTO"] = "ESPERANTO";
    LanguageEnum["ESTONIAN"] = "ESTONIAN";
    LanguageEnum["EWE"] = "EWE";
    LanguageEnum["FAROESE"] = "FAROESE";
    LanguageEnum["FARSI"] = "FARSI";
    LanguageEnum["FIJIAN"] = "FIJIAN";
    LanguageEnum["FINNISH"] = "FINNISH";
    LanguageEnum["FLEMISH"] = "FLEMISH";
    LanguageEnum["FRENCH"] = "FRENCH";
    LanguageEnum["FULA"] = "FULA";
    LanguageEnum["GAELIC"] = "GAELIC";
    LanguageEnum["GALICIAN"] = "GALICIAN";
    LanguageEnum["GANDA"] = "GANDA";
    LanguageEnum["GEORGIAN"] = "GEORGIAN";
    LanguageEnum["GERMAN"] = "GERMAN";
    LanguageEnum["GREEK"] = "GREEK";
    LanguageEnum["GUARANI"] = "GUARANI";
    LanguageEnum["GUJARATI"] = "GUJARATI";
    LanguageEnum["HAITIAN"] = "HAITIAN";
    LanguageEnum["HAUSA"] = "HAUSA";
    LanguageEnum["HEBREW"] = "HEBREW";
    LanguageEnum["HERERO"] = "HERERO";
    LanguageEnum["HINDI"] = "HINDI";
    LanguageEnum["HIRI_MOTU"] = "HIRI_MOTU";
    LanguageEnum["HMONG"] = "HMONG";
    LanguageEnum["HUNGARIAN"] = "HUNGARIAN";
    LanguageEnum["ICELANDIC"] = "ICELANDIC";
    LanguageEnum["IDO"] = "IDO";
    LanguageEnum["IGBO"] = "IGBO";
    LanguageEnum["ILOCANO"] = "ILOCANO";
    LanguageEnum["INDONESIAN"] = "INDONESIAN";
    LanguageEnum["INTERLINGUA"] = "INTERLINGUA";
    LanguageEnum["INTERLINGUE"] = "INTERLINGUE";
    LanguageEnum["INUKTITUT"] = "INUKTITUT";
    LanguageEnum["INUPIAQ"] = "INUPIAQ";
    LanguageEnum["IRISH"] = "IRISH";
    LanguageEnum["ITALIAN"] = "ITALIAN";
    LanguageEnum["JAPANESE"] = "JAPANESE";
    LanguageEnum["JAVANESE"] = "JAVANESE";
    LanguageEnum["KALAALLISUT"] = "KALAALLISUT";
    LanguageEnum["KANNADA"] = "KANNADA";
    LanguageEnum["KANURI"] = "KANURI";
    LanguageEnum["KASHMIRI"] = "KASHMIRI";
    LanguageEnum["KAZAKH"] = "KAZAKH";
    LanguageEnum["KHMER"] = "KHMER";
    LanguageEnum["KIKUYU"] = "KIKUYU";
    LanguageEnum["KINYARWANDA"] = "KINYARWANDA";
    LanguageEnum["KIRUNDI"] = "KIRUNDI";
    LanguageEnum["KOMI"] = "KOMI";
    LanguageEnum["KONGO"] = "KONGO";
    LanguageEnum["KOREAN"] = "KOREAN";
    LanguageEnum["KURDISH"] = "KURDISH";
    LanguageEnum["KWANYAMA"] = "KWANYAMA";
    LanguageEnum["KYRGYZ"] = "KYRGYZ";
    LanguageEnum["LAO"] = "LAO";
    LanguageEnum["LATIN"] = "LATIN";
    LanguageEnum["LATVIAN"] = "LATVIAN";
    LanguageEnum["LIMBURGISH"] = "LIMBURGISH";
    LanguageEnum["LINGALA"] = "LINGALA";
    LanguageEnum["LITHUANIAN"] = "LITHUANIAN";
    LanguageEnum["LUBAKATANGA"] = "LUBAKATANGA";
    LanguageEnum["LUXEMBOURGISH"] = "LUXEMBOURGISH";
    LanguageEnum["MACEDONIAN"] = "MACEDONIAN";
    LanguageEnum["MALAGASY"] = "MALAGASY";
    LanguageEnum["MALAY"] = "MALAY";
    LanguageEnum["MALAYALAM"] = "MALAYALAM";
    LanguageEnum["MALTESE"] = "MALTESE";
    LanguageEnum["MANDARIN"] = "MANDARIN";
    LanguageEnum["MANX"] = "MANX";
    LanguageEnum["MAORI"] = "MAORI";
    LanguageEnum["MARATHI"] = "MARATHI";
    LanguageEnum["MARSHALLESE"] = "MARSHALLESE";
    LanguageEnum["MONGOLIAN"] = "MONGOLIAN";
    LanguageEnum["NAURU"] = "NAURU";
    LanguageEnum["NAVAJO"] = "NAVAJO";
    LanguageEnum["NDONGA"] = "NDONGA";
    LanguageEnum["NEPALI"] = "NEPALI";
    LanguageEnum["NORTHERN_SAMI"] = "NORTHERN_SAMI";
    LanguageEnum["NORTH_NDEBELE"] = "NORTH_NDEBELE";
    LanguageEnum["NORWEGIAN"] = "NORWEGIAN";
    LanguageEnum["NUOSU"] = "NUOSU";
    LanguageEnum["OCCITAN"] = "OCCITAN";
    LanguageEnum["OJIBWE"] = "OJIBWE";
    LanguageEnum["ORIYA"] = "ORIYA";
    LanguageEnum["OROMO"] = "OROMO";
    LanguageEnum["OSSETIAN"] = "OSSETIAN";
    LanguageEnum["PALI"] = "P\u0100LI";
    LanguageEnum["PANJABI"] = "PANJABI";
    LanguageEnum["PUNJABI"] = "PUNJABI";
    LanguageEnum["PASHTO"] = "PASHTO";
    LanguageEnum["PERSIAN"] = "PERSIAN";
    LanguageEnum["POLISH"] = "POLISH";
    LanguageEnum["PORTUGUESE"] = "PORTUGUESE";
    LanguageEnum["QUECHUA"] = "QUECHUA";
    LanguageEnum["ROMANIAN"] = "ROMANIAN";
    LanguageEnum["ROMANSH"] = "ROMANSH";
    LanguageEnum["RUSSIAN"] = "RUSSIAN";
    LanguageEnum["SAMOAN"] = "SAMOAN";
    LanguageEnum["SANGO"] = "SANGO";
    LanguageEnum["SANSKRIT"] = "SANSKRIT";
    LanguageEnum["SARDINIAN"] = "SARDINIAN";
    LanguageEnum["SERBIAN"] = "SERBIAN";
    LanguageEnum["SERBO_CROATIAN"] = "SERBO_CROATIAN";
    LanguageEnum["SHONA"] = "SHONA";
    LanguageEnum["SIGN_LANGUAGE"] = "SIGN_LANGUAGE";
    LanguageEnum["SINDHI"] = "SINDHI";
    LanguageEnum["SINHALA"] = "SINHALA";
    LanguageEnum["SLOVAK"] = "SLOVAK";
    LanguageEnum["SLOVENE"] = "SLOVENE";
    LanguageEnum["SOMALI"] = "SOMALI";
    LanguageEnum["SOUTH_AZERBAIJANI"] = "SOUTH_AZERBAIJANI";
    LanguageEnum["SOUTHERN_SOTHO"] = "SOUTHERN_SOTHO";
    LanguageEnum["SPANISH"] = "SPANISH";
    LanguageEnum["SUNDANESE"] = "SUNDANESE";
    LanguageEnum["SWAHILI"] = "SWAHILI";
    LanguageEnum["SWATI"] = "SWATI";
    LanguageEnum["SWEDISH"] = "SWEDISH";
    LanguageEnum["TAGALOG"] = "TAGALOG";
    LanguageEnum["TAHITIAN"] = "TAHITIAN";
    LanguageEnum["TAJIK"] = "TAJIK";
    LanguageEnum["TAMIL"] = "TAMIL";
    LanguageEnum["TATAR"] = "TATAR";
    LanguageEnum["TELUGU"] = "TELUGU";
    LanguageEnum["THAI"] = "THAI";
    LanguageEnum["TIBETAN"] = "TIBETAN";
    LanguageEnum["TIGRINYA"] = "TIGRINYA";
    LanguageEnum["TONGA"] = "TONGA";
    LanguageEnum["TSONGA"] = "TSONGA";
    LanguageEnum["TSWANA"] = "TSWANA";
    LanguageEnum["TURKISH"] = "TURKISH";
    LanguageEnum["TURKMEN"] = "TURKMEN";
    LanguageEnum["TWI"] = "TWI";
    LanguageEnum["UKRAINIAN"] = "UKRAINIAN";
    LanguageEnum["URDU"] = "URDU";
    LanguageEnum["UYGHUR"] = "UYGHUR";
    LanguageEnum["UZBEK"] = "UZBEK";
    LanguageEnum["VENDA"] = "VENDA";
    LanguageEnum["VIETNAMESE"] = "VIETNAMESE";
    LanguageEnum["VOLAPUK"] = "VOLAPUK";
    LanguageEnum["WALLOON"] = "WALLOON";
    LanguageEnum["WELSH"] = "WELSH";
    LanguageEnum["WESTERN_FRISIAN"] = "WESTERN_FRISIAN";
    LanguageEnum["WOLOF"] = "WOLOF";
    LanguageEnum["XHOSA"] = "XHOSA";
    LanguageEnum["YIDDISH"] = "YIDDISH";
    LanguageEnum["YORUBA"] = "YORUBA";
    LanguageEnum["ZHUANG"] = "ZHUANG";
    LanguageEnum["ZULU"] = "ZULU";
})(LanguageEnum = exports.LanguageEnum || (exports.LanguageEnum = {}));
var MartindaleHubbellRatingEnum;
(function (MartindaleHubbellRatingEnum) {
    MartindaleHubbellRatingEnum["AV"] = "AV";
    MartindaleHubbellRatingEnum["BV"] = "BV";
    MartindaleHubbellRatingEnum["CV"] = "CV";
    MartindaleHubbellRatingEnum["AV_PREEMINENT"] = "AV_PREEMINENT";
    MartindaleHubbellRatingEnum["DISTINGUISHED"] = "DISTINGUISHED";
    MartindaleHubbellRatingEnum["NOTABLE"] = "NOTABLE";
    MartindaleHubbellRatingEnum["NOT_RATED"] = "NOT_RATED";
})(MartindaleHubbellRatingEnum = exports.MartindaleHubbellRatingEnum || (exports.MartindaleHubbellRatingEnum = {}));
var FileUploadType;
(function (FileUploadType) {
    FileUploadType["AWARD"] = "AWARD";
    FileUploadType["CERTIFICATE_OF_INSURANCE"] = "CERTIFICATE_OF_INSURANCE";
    FileUploadType["CERTIFICATE"] = "CERTIFICATE";
    FileUploadType["OTHER"] = "OTHER";
    FileUploadType["PUBLICATION"] = "PUBLICATION";
    FileUploadType["QUESTIONNAIRE"] = "QUESTIONNAIRE";
    FileUploadType["PROFILE_IMAGE"] = "PROFILE_IMAGE";
})(FileUploadType = exports.FileUploadType || (exports.FileUploadType = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["DEACTIVATION_NOTICE"] = "DEACTIVATION_NOTICE";
    NotificationType["INSURANCEUPDATE1"] = "INSURANCE_UPDATE_1";
    NotificationType["INSURANCEUPDATE2"] = "INSURANCE_UPDATE_2";
    NotificationType["INSURANCEUPDATE3"] = "INSURANCE_UPDATE_3";
    NotificationType["OTHER"] = "OTHER";
    NotificationType["PASSWORD_RESET"] = "PASSWORD_RESET";
    NotificationType["REFERRAL_APPLICATION_RESULT"] = "REFERRAL_APPLICATION_RESULT";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["PENDING"] = "PENDING";
    VerificationStatus["PASS"] = "PASS";
    VerificationStatus["FAIL"] = "FAIL";
})(VerificationStatus = exports.VerificationStatus || (exports.VerificationStatus = {}));
var Flag;
(function (Flag) {
    Flag["CONFERENCES"] = "CONFERENCES";
})(Flag = exports.Flag || (exports.Flag = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://providers.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Providers Service Api
 * @version v1
 * @baseUrl https://providers.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersGetProviders
             * @request GET:/v1/providers
             * @secure
             */
            providersGetProviders: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersCreateProvider
             * @request POST:/v1/providers
             * @secure
             */
            providersCreateProvider: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersGetProviderById
             * @request GET:/v1/providers/{providerId}
             * @secure
             */
            providersGetProviderById: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersDeleteResource
             * @request DELETE:/v1/providers/{providerId}
             * @secure
             */
            providersDeleteResource: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersGetBranchesByList
             * @request POST:/v1/providers/getProvidersByIdList
             * @secure
             */
            providersGetBranchesByList: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/getProvidersByIdList`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateProviderName
             * @request POST:/v1/providers/{providerId}/updateName
             * @secure
             */
            providersUpdateProviderName: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdatePracticeBeginDate
             * @request POST:/v1/providers/{providerId}/updatePracticeBeginDate
             * @secure
             */
            providersUpdatePracticeBeginDate: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updatePracticeBeginDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateContactInfo
             * @request POST:/v1/providers/{providerId}/updateContactInformation
             * @secure
             */
            providersUpdateContactInfo: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateContactInformation`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateWebsiteUrl
             * @request POST:/v1/providers/{providerId}/updateWebsiteUrl
             * @secure
             */
            providersUpdateWebsiteUrl: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateWebsiteUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateBiography
             * @request POST:/v1/providers/{providerId}/updateBiography
             * @secure
             */
            providersUpdateBiography: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateBiography`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateFirmId
             * @request POST:/v1/providers/{providerId}/updateFirmId
             * @secure
             */
            providersUpdateFirmId: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateFirmId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateBranches
             * @request POST:/v1/providers/{providerId}/updateBranchAssociations
             * @secure
             */
            providersUpdateBranches: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateBranchAssociations`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateEmailAddress
             * @request POST:/v1/providers/{providerId}/updateEmailAddress
             * @secure
             */
            providersUpdateEmailAddress: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateEmailAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAddresses
             * @request POST:/v1/providers/{providerId}/updateAddresses
             * @secure
             */
            providersUpdateAddresses: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAddresses`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdatePhoneNumbers
             * @request POST:/v1/providers/{providerId}/updatePhoneNumbers
             * @secure
             */
            providersUpdatePhoneNumbers: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updatePhoneNumbers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAreasOfPractice
             * @request POST:/v1/providers/{providerId}/updateAreasOfPractice
             * @secure
             */
            providersUpdateAreasOfPractice: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAreasOfPractice`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateLanguages
             * @request POST:/v1/providers/{providerId}/updateLanguages
             * @secure
             */
            providersUpdateLanguages: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateLanguages`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAwards
             * @request POST:/v1/providers/{providerId}/updateAwards
             * @secure
             */
            providersUpdateAwards: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAwards`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAssociations
             * @request POST:/v1/providers/{providerId}/updateAssociations
             * @secure
             */
            providersUpdateAssociations: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAssociations`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateEducation
             * @request POST:/v1/providers/{providerId}/updateEducation
             * @secure
             */
            providersUpdateEducation: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateEducation`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdatePublications
             * @request POST:/v1/providers/{providerId}/updatePublications
             * @secure
             */
            providersUpdatePublications: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updatePublications`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateSpeakingEngagements
             * @request POST:/v1/providers/{providerId}/updateSpeakingEngagements
             * @secure
             */
            providersUpdateSpeakingEngagements: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateSpeakingEngagements`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateProfilePicUrl
             * @request POST:/v1/providers/{providerId}/updateProfilePicUrl
             * @secure
             */
            providersUpdateProfilePicUrl: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateProfilePicUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateRating
             * @request POST:/v1/providers/{providerId}/updateRating
             * @secure
             */
            providersUpdateRating: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateRating`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateRating2
             * @request POST:/v1/providers/{providerId}/addNotificationHistory
             * @secure
             */
            providersUpdateRating2: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/addNotificationHistory`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateProviderTypes
             * @request POST:/v1/providers/{providerId}/updateProviderTypes
             * @secure
             */
            providersUpdateProviderTypes: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateProviderTypes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateLegalShieldJoinYear
             * @request POST:/v1/providers/{providerId}/updateLegalShieldJoinYear
             * @secure
             */
            providersUpdateLegalShieldJoinYear: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateLegalShieldJoinYear`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateBarStates
             * @request POST:/v1/providers/{providerId}/updateBarStates
             * @secure
             */
            providersUpdateBarStates: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateBarStates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateBarState
             * @request POST:/v1/providers/{providerId}/updateBarState
             * @secure
             */
            providersUpdateBarState: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateBarState`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersAddBarState
             * @request POST:/v1/providers/{providerId}/addBarState
             * @secure
             */
            providersAddBarState: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/addBarState`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersRemoveBarState
             * @request POST:/v1/providers/{providerId}/removeBarState
             * @secure
             */
            providersRemoveBarState: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/removeBarState`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateCriticalNotes
             * @request POST:/v1/providers/{providerId}/updateCriticalNotes
             * @secure
             */
            providersUpdateCriticalNotes: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateCriticalNotes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateReferringEntity
             * @request POST:/v1/providers/{providerId}/updateReferringEntity
             * @secure
             */
            providersUpdateReferringEntity: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateReferringEntity`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateTaxId
             * @request POST:/v1/providers/{providerId}/updateTaxId
             * @secure
             */
            providersUpdateTaxId: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateTaxId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateDisciplinaryActions
             * @request POST:/v1/providers/{providerId}/updateDisciplinaryActions
             * @secure
             */
            providersUpdateDisciplinaryActions: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateDisciplinaryActions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateVerification
             * @request POST:/v1/providers/{providerId}/updateVerification
             * @secure
             */
            providersUpdateVerification: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateVerification`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersActivate
             * @request POST:/v1/providers/{providerId}/activate
             * @secure
             */
            providersActivate: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersDeactivate
             * @request POST:/v1/providers/{providerId}/deactivate
             * @secure
             */
            providersDeactivate: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/deactivate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersSuspend
             * @request POST:/v1/providers/{providerId}/suspend
             * @secure
             */
            providersSuspend: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersAddFileUpload
             * @request POST:/v1/providers/{providerId}/addFileUpload
             * @secure
             */
            providersAddFileUpload: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/addFileUpload`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersRemoveFileUpload
             * @request POST:/v1/providers/{providerId}/removeFileUpload
             * @secure
             */
            providersRemoveFileUpload: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/removeFileUpload`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateFileUploads
             * @request POST:/v1/providers/{providerId}/updateFileUploads
             * @secure
             */
            providersUpdateFileUploads: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateFileUploads`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateFlags
             * @request POST:/v1/providers/{providerId}/updateFlags
             * @secure
             */
            providersUpdateFlags: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateFlags`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateInsurance
             * @request POST:/v1/providers/{providerId}/updateInsurance
             * @secure
             */
            providersUpdateInsurance: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateInsurance`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateExternalId
             * @request POST:/v1/providers/{providerId}/updateExternalId
             * @secure
             */
            providersUpdateExternalId: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateExternalId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersMarkInsuranceExpired
             * @request POST:/v1/providers/{providerId}/markInsuranceExpired
             * @secure
             */
            providersMarkInsuranceExpired: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/markInsuranceExpired`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersMarkInsuranceNeedsAttention
             * @request POST:/v1/providers/{providerId}/markInsuranceNeedsAttention
             * @secure
             */
            providersMarkInsuranceNeedsAttention: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/markInsuranceNeedsAttention`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersMarkPendingInsuranceExpiration
             * @request POST:/v1/providers/{providerId}/markPendingInsuranceExpiration
             * @secure
             */
            providersMarkPendingInsuranceExpiration: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/markPendingInsuranceExpiration`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAcceptingReferrals
             * @request POST:/v1/providers/{providerId}/updateAcceptingReferrals
             * @secure
             */
            providersUpdateAcceptingReferrals: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAcceptingReferrals`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateNetwork
             * @request POST:/v1/providers/{providerId}/updateNetwork
             * @secure
             */
            providersUpdateNetwork: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateNetwork`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProvidersJournal
             * @name ProvidersJournalGetJournalChanges
             * @request GET:/v1/providers/journal
             * @secure
             */
            providersJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=providers.js.map